import type { FilterConfig } from '#types/config/components/filter'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    base: 'rounded-xs b-grey-70',
    selected: 'bg-brand-1 c-brand-2',
  }
} satisfies RecursivePartial<FilterConfig['option']['tileExpanded']>
